/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:43:09
 */
export default {
  lang: "英语",
  landing: {
    name1: "Buka Carlcare",
    name2: "Buat tempahan",
    name3: "Dengan Carlcare, anda boleh menyemak pesanan anda pada bila-bila masa.",
    name4: "",
    name5: "Seret ke kanan",
    name6: "Pengesahan selesai",
     name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from ₱500, you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    // name16: "Lower and Transparent Pricing",
    // name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy a 3-month warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. If you join the flat price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.",
    name31: "Carlcare Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Pilih model peranti",
    name2: "Perihalan Kegagalan:",
    name3: "Ketik untuk memilih kedai servis",
    name4: "Kedai Servis:",
    name5: "Masa Tempahan:",
    name6: "Sila terangkan masalah peranti anda secara terperinci!",
    name7: "Ketik untuk memilih masa ketibaan",
    name8: "Sila masukkan maklumat hubungan anda yang betul agar kami dapat menghubungi anda",
    name9: "Masa tempahan yang tersedia adalah seperti berikut",
    name10: "Sila masukkan nombor telefon anda",
    name11: "Harga",
    name12: "Maklumat Peribadi:",
    name13: "Sila masukkan nama anda",
    name14: "Serah",
    name15: "Batal",
    name16: "OK",
  },
  shops: {
    name1: "Berdasarkan jenama yang anda pilih, kedai berikut boleh melayani anda!",
    name2: "Akan datang ke lebih banyak kedai runcit! Teruskan bersama kami!",
  },
  price: {
    name1: "Jenama",
    name2: "Model",
    name3: "ITEM",
    name4: "Harga",
    name5: "Peringatan Mesra:",
    name6: "Harga ini hanya untuk rujukan dan harga sebenar adalah tertakluk kepada keadaan peranti anda.",
    name7: "Jika tiada simbol khas, unit harga ialah unit mata wang tempatan.",
    name8: "Maaf! Tiada maklumat harga yang tersedia di rantau semasa.",
    name11:"Kos Buruh",
    name12:"Jumlah Harga",
    name13: "5. Jika kos buruh adalah \"/\", ini bermakna kos buruh perlu dirujuk dengan kedai.",
    item_main_board: "Papan Utama",
    item_screen_frame: "Skrin (Bingkai)",
    item_screen_screen_frame: "Skrin Sekunder (Bingkai)",
    item_touch_screen: "Skrin Sentuh",
    item_camera: "\"Kamera\"",
    item_fixed_focus_camera: "Kamera Fokus Tetap",
    item_auto_focus_camera: "Kamera Fokus Auto",
    item_screen: "Skrin",
    item_secondary_screen: "Skrin Sekunder",
    item_fingerprint_module: "Modul Cap Jari",
    item_speaker: "Pembesar Suara",
    item_receiver: "Penerima",
    item_small_board: "Papan Kecil",
    item_battery_cover: "Penutup Bateri",
    item_battery: "Bateri",
    item_charger: "Pengecas",
    item_usb_cable: "Kabel USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Tiada data",
    name2: "Penyedia Perkhidmatan:",
    name3: "Jenama Perkhidmatan:",
    name4: "Telefon:",
    name5: "Kuantiti Pesanan:",
    name6: "Penarafan Perkhidmatan",
    name7: "Persekitaran Perkhidmatan:",
    name8: "Sikap Perkhidmatan:",
    name9: "Kecekapan Perkhidmatan:",
    name10: "Kualiti Perkhidmatan:",
    name11: "Penilaian Pelanggan",
    name12:"hingga",
    name13:"Ditutup",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Buka Carlcare",
    name1: "Sila ambil petikan skrin maklumat tempahan dan simpan ia sebagai resit untuk mengakses perkhidmatan keutamaan.",
    name2: "Berjaya diserahkan",
    name3: "1. Kosongkan data",
    name4: "Sila sandarkan data peribadi pada telefon anda terlebih dahulu",
    name5: "2. Nyahdayakan kata laluan hidupkan kuasa",
    name6: "Sebelum pergi ke kedai perkhidmatan, sila:",
    name7: "Kedai Servis:",
    name8: "Masa Tempahan:",
    name9: "Perihalan Kegagalan:",
    name10: "Model Peranti:",
    name11: "Nombor Pesanan:",
    name12: "Maklumat Pesanan",
  },
  title: {
    
    name1: "Menyokong negara berikut:",
    name2: "Pilih Model",
    name3: "Tempahan",
    name4: "Butiran Kedai Servis",
    name5: "Pilih Kedai Servis",
  },
  error: {
    
    name1: "Tiada data. Sila semak maklumat pembaikan anda",
    name2: "Perlu bantuan lanjut? Sila hubungi kami.",
    name3: "Maaf, tiada pusat Carlcare di rantau semasa.",
    name4: "Sila pilih satu pusat perkhidmatan dahulu!",
    name5: "Gagal",
    name6: "Sila pilih model peranti terlebih dahulu",
    name7: "Butiran",
    name8: "Sila terangkan keperluan anda dengan terperinci",
    name9: "",
  },
  add1:{
    "name0": "ms-rMY",
    "name1": "Pesanan anda telah disahkan. Kami tidak sabar menanti ketibaan anda.",
    "name2": "Pilih bandar",
    "name3": "Sila masukkan nombor telefon %1$s digit.",
    "name4": "Jam Hari Biasa",
    "name5": "\"Isnin\"",
    "name6": "Selasa",
    "name7": "Rabu",
    "name8": "Khamis",
    "name9": "Jumaat",
    "name10": "\"Sabtu\"",
    "name11": "\"Ahad\"",
    "name12": "Masukkan negara dan cari"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Lain-lain",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Ketik untuk Mengubah Hala",
    name3:"Buka aplikasi Carlcare untuk menilai pesanan",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Pilih Perkhidmatan",
    name7:"Pembersihan Percuma",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Maklumat tidak betul",
    "cancelReason1": "Tidak boleh tiba pada masa",
    "cancelReason2": "Pesanan pendua/bukan pesanan saya",
    "cancelReason3": "Kegagalan tidak berulang",
    "cancelReason4": "Hanya untuk ujian/pertanyaan/acara/…",
    "cancelReason5": "Harga tinggi",
    "cancelReason6": "Kekurangan bahan",
    "cancelReason7": "Tiada perkhidmatan yang berbeza",
    "cancelReason8": "Kedai terlalu jauh",
    "cancelReason9": "Kedai ditutup",
    "cancelReason10": "Sikap perkhidmatan yang buruk",
    "cancelReason11": "Penggantian/pembaikan untuk jenama lain",
    "cancelReason12": "Tidak dapat mencari kedai",
    "cancelReason13": "Lain-lain",
    "cancelOrder": "Batalkan Pesanan",
    "reason_dialog_title": "Mohon beritahu kami sebab pembatalan",
    "Cancel": "Batal",
    "OK": "Ok",
    "name1": "Masukkan kod pengesahan",
    "name2": "Kod pengesahan tidak sah",
    "repair_reservation_detail_canceled": "Pesanan ini telah Dibatalkan!",
    "purchase_cancel_dialog_content": "Adakah anda mengesahkan untuk membatalkan pesanan?",
    "yes": "\"Ya\"",
    "no": "\"Tidak\""
}
};
